//updated one 
import React, { useState, useEffect } from "react";
import {
  User,
  Calendar,
  FileText,
  Clock,
  ChevronRight,
  ArrowLeft, 
  X,
  LogIn,
  LogOut,
  Briefcase, // Added for working hours modal
  Sunrise, // Added for check-in/out visual
  Sunset, // Added for check-in/out visual
} from "lucide-react";  
import { useNavigate } from "react-router-dom";
import {
  getEmployeeData,
  getDashboardStats,
  getMyLeaves,
  getMyLeaveBalance,
  // getAttendanceCalendar, // We will use dummy data or your new API for the attendance page
} from "../../services/hrms.service";
import { getTeamEmployees } from "../../services/hrms.service";

const ManagerMyInfo = () => {
  const navigate = useNavigate();

  // Get current user to determine role and employeeRef
  const getCurrentUser = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user;
  };

  const user = getCurrentUser();
  const isManager = user?.role === "MANAGER";
  const employeeRef = user?.employeeRef; // Get employeeRef for API calls

  // State variables from the old code, updated with new stats and todayAttendance
  const [employeeData, setEmployeeData] = useState({
    name: "Loading...",
    empId: "",
    email: "",
    department: "",
    designation: "",
    joiningDate: "",
    reportingManager: "",
  });

  const [stats, setStats] = useState({
    attendanceThisMonth: 0,
    totalWorkingDays: 26,
    leaveBalance: 0,
    pendingLeaves: 0,
    approvedLeaves: 0,
    totalHoursWorked: 0, // Will be fetched or calculated
    overtimeHours: 0, // Will be fetched or calculated
    expectedHours: 176, // Kept for consistency, not displayed here
  });
const [leaveBreakdown, setLeaveBreakdown] = useState({
  casual: 0,
  sick: 0,
  earned: 0
});

  // New state for today's check-in/check-out
  const [todayAttendance, setTodayAttendance] = useState({
    checkIn: "09:00 AM",
    checkOut: "06:00 PM", 
    status: "Present", 
  });

  const [recentLeaves, setRecentLeaves] = useState([]);
  const [allLeaves, setAllLeaves] = useState([]); // To store all leaves for the modal
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Modal states - All from old code + new ones
  // No longer needed: showAttendanceModal (redirects to page)
  const [showLeaveBalanceModal, setShowLeaveBalanceModal] = useState(false);
  const [showPendingLeavesModal, setShowPendingLeavesModal] = useState(false);
  const [showAllLeavesModal, setShowAllLeavesModal] = useState(false); // New for "View All" leaves
  const [showWorkingHoursModal, setShowWorkingHoursModal] = useState(false); // New for Working Hours details

  // Removed attendanceCalendar and currentMonth as attendance is a separate page now

  // Team preview state (manager only)
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamLoading, setTeamLoading] = useState(false);

  // Handler for back button - dynamic based on role
  const handleBack = () => {
    if (isManager) {
      navigate("/hrms/manager-dashboard");
    } else {
      navigate("/hrms/employee-dashboard");
    }
  };

  // Handler for "Apply Leave" button - dynamic based on role
  const handleApplyLeave = () => {
    if (isManager) {
      navigate("/hrms/manager/apply-leave");
    } else {
      navigate("/hrms/employee/apply-leave");
    }
  };

  // Handler for "Attendance" card click - dynamic based on role
  const handleViewAttendance = () => {
    if (isManager) {
      navigate("/hrms/manager/my-attendance");
    } else {
      navigate("/hrms/employee/my-attendance");
    }
  };

  // Function to load all dashboard data
  const loadDashboardData = async () => {
    try {
      setLoading(true);
      setError(null);

      if (!user || !employeeRef) {
        setError("No employee data found. Please login again.");
        return;
      }

      // Fetch employee data
      const employeeResponse = await getEmployeeData(employeeRef);
      // if (employeeResponse.status === 1 && employeeResponse.data) {
      //   const empData = employeeResponse.data;
      //   setEmployeeData({
      //     name: `${empData.firstName || ""} ${empData.lastName || ""}`.trim() || "N/A",
      //     empId: empData.employeeId || "N/A",
      //     email: empData.email || "N/A",
      //     department: empData.department || "N/A",
      //     designation: empData.designation || "N/A",
      //     joiningDate: empData.joiningDate
      //       ? new Date(empData.joiningDate).toLocaleDateString()
      //       : "N/A",
      //     reportingManager: empData.reportingManager || "N/A",
      //   });
      // }
      if (employeeResponse.status === 1 && employeeResponse.data) {
        const empData = employeeResponse.data.employeeData || employeeResponse.data; // prefer nested employeeData
        setEmployeeData({
          name: `${empData.first_name || ""} ${empData.last_name || ""}`.trim() || "N/A",
          empId: empData.employee_id || "N/A",
          email: empData.email || "N/A",
          department: empData.department || "N/A",
          designation: empData.joining_position || empData.designation || "N/A",
          joiningDate: empData.joining_date
            ? new Date(empData.joining_date).toLocaleDateString()
            : "N/A",
          reportingManager: empData.reporting_manager || "N/A",
        });
      }
      // Fetch dashboard statistics
      const statsResponse = await getDashboardStats(employeeRef);
      if (statsResponse.status === 1 && statsResponse.data) {
        setStats({
          attendanceThisMonth: statsResponse.data.attendanceThisMonth || 0,
          totalWorkingDays: statsResponse.data.totalWorkingDays || 26,
          leaveBalance: statsResponse.data.leaveBalance || 0,
          pendingLeaves: statsResponse.data.pendingLeaves || 0,
          approvedLeaves: statsResponse.data.approvedLeaves || 0,
          totalHoursWorked: statsResponse.data.totalHoursWorked || 0,
          overtimeHours: statsResponse.data.overtimeHours || 0,
          expectedHours: statsResponse.data.expectedHours || 176, // Default or fetched
        });
      }

      // Fetch leave balance from API
      // const leaveBalanceResponse = await getMyLeaveBalance();
      // if (leaveBalanceResponse.status === 1 && leaveBalanceResponse.data) {
      //   // API returns an array of leave balance objects, calculate total balance
      //   let totalBalance = 0;
      //   if (Array.isArray(leaveBalanceResponse.data)) {
      //     totalBalance = leaveBalanceResponse.data.reduce((sum, item) => {
      //       return sum + (item.balance || item.remaining_balance || 0);
      //     }, 0);
      //   }
      //   setStats(prevStats => ({
      //     ...prevStats,
      //     leaveBalance: totalBalance
      //   }));
      // }
// Fetch leave balance from API
const leaveBalanceResponse = await getMyLeaveBalance();

if (leaveBalanceResponse.status === 1 && leaveBalanceResponse.data) {
  
  let totalBalance = 0;

  // break down balances
  let casual = 0, sick = 0, earned = 0;

  leaveBalanceResponse.data.forEach(item => {
    const balance = parseFloat(item.balance || 0);
    totalBalance += balance;

    if (item.code === "CASUAL") casual = balance;
    if (item.code === "SICK") sick = balance;
    if (item.code === "EARNED") earned = balance;
  });

  setStats(prev => ({
    ...prev,
    leaveBalance: totalBalance
  }));

  setLeaveBreakdown({ casual, sick, earned });
}

      // Fetch pending leaves count
      const myLeavesResponse = await getMyLeaves(1, 100); // Get all leaves to count pending
      if (myLeavesResponse.status === 1 && myLeavesResponse.data) {
        const pendingCount = myLeavesResponse.data.filter(leave => leave.status?.toLowerCase() === 'pending').length;
        setStats(prevStats => ({
          ...prevStats,
          pendingLeaves: pendingCount
        }));
      }

      // Fetch recent leaves (e.g., last 3-5 for the main view)
      const leavesResponse = await getMyLeaves(1, 5); // my-leaves
      if (leavesResponse.status === 1 && leavesResponse.data) {
        const formattedLeaves = leavesResponse.data.map((leave) => ({
          id: leave.id,
          type: leave.leave_type_name || "Leave",
          fromDate: leave.start_date ? new Date(leave.start_date).toLocaleDateString() : "N/A",
          toDate: leave.end_date ? new Date(leave.end_date).toLocaleDateString() : "N/A",
          status: leave.status || "Pending",
          days: leave.total_days || 1,
          reason: leave.reason || "",
        }));
        setRecentLeaves(formattedLeaves);
      } else {
        setRecentLeaves([]);
      }

      // Fetch ALL leaves for the "View All" modal
      const allLeavesResponse = await getMyLeaves(1, 100); // Fetching a larger number for "all"
      if (allLeavesResponse.status === 1 && allLeavesResponse.data) {
        const formattedAllLeaves = allLeavesResponse.data.map((leave) => ({
          id: leave.id,
          type: leave.leave_type_name || "Leave",
          fromDate: leave.start_date ? new Date(leave.start_date).toLocaleDateString() : "N/A",
          toDate: leave.end_date ? new Date(leave.end_date).toLocaleDateString() : "N/A",
          status: leave.status || "Pending",
          days: leave.total_days || 1,
          reason: leave.reason || "",
          appliedOn: leave.created_at ? new Date(leave.created_at).toLocaleDateString() : "N/A",
        }));
        setAllLeaves(formattedAllLeaves);
      } else {
        setAllLeaves([]);
      }

      // Manager-only: fetch a small team preview
      if (isManager) {
        try {
          setTeamLoading(true);
          const teamResp = await getTeamEmployees(1, 5);
          if (teamResp.status === 1 && Array.isArray(teamResp.data)) {
            const members = teamResp.data.map((item) => {
              const e = item.employeeData || item;
              return {
                id: e.id,
                name: `${e.first_name || ""} ${e.last_name || ""}`.trim() || "N/A",
                department: e.department || "N/A",
                designation: e.joining_position || e.designation || "N/A",
                profilePic: e.profile_pic || "",
              };
            });
            setTeamMembers(members);
          } else {
            setTeamMembers([]);
          }
        } catch (e) {
          setTeamMembers([]);
        } finally {
          setTeamLoading(false);
        }
      }

      // Dummy data for today's attendance for demonstration
      setTodayAttendance({
        checkIn: "09:15 AM",
        checkOut: "06:30 PM",
        status: "Present",
      });

    } catch (err) {
      console.error("Error loading dashboard data:", err);
      setError("Failed to load dashboard data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDashboardData();
  }, [employeeRef]); // Rerun when employeeRef changes

  // Helper function for status badges
  const getStatusBadge = (status) => {
    const styles = {
      Approved: "bg-emerald-500",
      Pending: "bg-amber-500",
      Rejected: "bg-rose-500",
    };
    return styles[status] || "bg-gray-500";
  };

  // Filter pending leaves for the pending leaves modal
  const pendingLeavesOnly = recentLeaves.filter(l => l.status.toLowerCase() === 'pending');

  // Calculate total hours for today's attendance card
  const calculateDailyHours = (checkInStr, checkOutStr) => {
    if (!checkInStr || !checkOutStr) return "N/A";
    const checkInTime = new Date(`2000/01/01 ${checkInStr}`); // Use a dummy date
    const checkOutTime = new Date(`2000/01/01 ${checkOutStr}`);
    if (isNaN(checkInTime) || isNaN(checkOutTime)) return "N/A";
    const diffMs = checkOutTime - checkInTime;
    const diffHours = diffMs / (1000 * 60 * 60);
    return `${diffHours.toFixed(1)}h`;
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading your information...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 text-6xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Error Loading Data</h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="bg-indigo-600 text-white px-6 py-2 rounded-lg hover:bg-indigo-700 transition"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Back Button */}
        <button
          onClick={handleBack}
          className="flex items-center text-indigo-600 hover:text-indigo-700 mb-6 font-medium"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          {isManager ? "Back to Team Dashboard" : "Back to Dashboard"}
        </button>

        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">My Information</h1>
          <p className="text-gray-600">View your personal details and statistics</p>
        </div>

        {/* Stats Grid - First Row */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          {/* Attendance Card - NOW REDIRECTS TO PAGE */}
          <div
            onClick={handleViewAttendance}
            className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition border border-gray-100 cursor-pointer"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="p-3 bg-indigo-50 rounded-xl">
                <Calendar className="w-6 h-6 text-indigo-600" />
              </div>
              <div className="text-right">
                <p className="text-3xl font-bold text-gray-800">
                  {stats.attendanceThisMonth}
                </p>
                <p className="text-xs text-gray-500">/{stats.totalWorkingDays} days</p>
              </div>
            </div>
            <h3 className="text-sm font-semibold text-gray-700">Attendance</h3>
            <p className="text-xs text-gray-500 mt-1">Click to view calendar</p>
            <div className="mt-4 bg-gray-100 rounded-full h-2">
              <div
                className="bg-indigo-500 h-2 rounded-full"
                style={{
                  width: `${(stats.attendanceThisMonth / stats.totalWorkingDays) * 100}%`,
                }}
              ></div>
            </div>
          </div>

          {/* Leave Balance Card - CLICKABLE */}
          <div
            onClick={() => setShowLeaveBalanceModal(true)}
            className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition border border-gray-100 cursor-pointer"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="p-3 bg-emerald-50 rounded-xl">
                <FileText className="w-6 h-6 text-emerald-600" />
              </div>
              <div className="text-right">
                <p className="text-3xl font-bold text-gray-800">{stats.leaveBalance}</p>
                <p className="text-xs text-gray-500">days left</p>
              </div>
            </div>
            <h3 className="text-sm font-semibold text-gray-700">Leave Balance</h3>
            <p className="text-xs text-gray-500 mt-1">Click to view details</p>
          </div>

          {/* Pending Leaves Card - CLICKABLE */}
          <div
            onClick={() => setShowPendingLeavesModal(true)}
            className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition border border-gray-100 cursor-pointer"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="p-3 bg-amber-50 rounded-xl">
                <Clock className="w-6 h-6 text-amber-600" />
              </div>
              <div className="text-right">
                <p className="text-3xl font-bold text-gray-800">{stats.pendingLeaves}</p>
                <p className="text-xs text-gray-500">request{stats.pendingLeaves !== 1 ? "s" : ""}</p>
              </div>
            </div>
            <h3 className="text-sm font-semibold text-gray-700">Pending Leaves</h3>
            <p className="text-xs text-gray-500 mt-1">Click to view requests</p>
          </div>

          {/* Total Hours Card - NOW CLICKABLE AND SHOWS OVERTIME */}
          <div
            onClick={() => setShowWorkingHoursModal(true)}
            className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition border border-gray-100 cursor-pointer"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="p-3 bg-blue-50 rounded-xl">
                <Clock className="w-6 h-6 text-blue-600" />
              </div>
              <div className="text-right">
                <p className="text-3xl font-bold text-gray-800">{stats.totalHoursWorked}h</p>
                <p className="text-xs text-gray-500">+{stats.overtimeHours}h OT</p>
              </div>
            </div>
            <h3 className="text-sm font-semibold text-gray-700">Working Hours</h3>
            <p className="text-xs text-gray-500 mt-1">Click for breakdown</p>
          </div>
        </div>

        {/* Today's Check-in/Check-out Card - NEW CARD */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
          <div className="lg:col-span-1 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 shadow-sm border border-blue-200">
            <h3 className="text-lg font-bold text-blue-900 mb-4 flex items-center">
              <Calendar className="w-5 h-5 mr-2" /> Today's Attendance
            </h3>
            <div className="space-y-4">
              <div className="bg-white rounded-xl p-4 flex items-center justify-between shadow-sm">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                    <LogIn className="w-5 h-5 text-green-600" />
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Check In</p>
                    <p className="text-lg font-bold text-gray-800">{todayAttendance.checkIn}</p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl p-4 flex items-center justify-between shadow-sm">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                    <LogOut className="w-5 h-5 text-red-600" />
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Check Out</p>
                    <p className="text-lg font-bold text-gray-800">{todayAttendance.checkOut}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 flex items-center justify-between px-2 py-2 bg-blue-100 rounded-lg text-blue-800 border border-blue-200">
              <span className="text-sm font-medium">Status: {todayAttendance.status}</span>
              <span className="text-sm font-medium">
                Total: {calculateDailyHours(todayAttendance.checkIn, todayAttendance.checkOut)}
              </span>
            </div>
          </div>

          {/* Profile Card */}
          <div className="lg:col-span-1 bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="bg-gradient-to-br from-indigo-500 to-blue-500 h-24"></div>
            <div className="px-6 pb-6 -mt-12">
              <div className="w-20 h-20 rounded-2xl bg-white shadow-lg flex items-center justify-center mb-4">
                <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-500 flex items-center justify-center text-white text-2xl font-bold">
                  {employeeData.name.charAt(0)}
                </div>
              </div>
              <h2 className="text-xl font-bold text-gray-800 mb-1">{employeeData.name}</h2>
              <p className="text-sm text-gray-500 mb-4">{employeeData.designation}</p>

              <div className="space-y-3 mb-6">
                <div className="flex items-center text-sm">
                  <span className="text-gray-500 w-24">Emp ID:</span>
                  <span className="font-semibold text-gray-800">{employeeData.empId}</span>
                </div>
                <div className="flex items-center text-sm">
                  <span className="text-gray-500 w-24">Email:</span>
                  <span className="font-semibold text-gray-800 truncate">{employeeData.email}</span>
                </div>
                <div className="flex items-center text-sm">
                  <span className="text-gray-500 w-24">Department:</span>
                  <span className="font-semibold text-gray-800">{employeeData.department}</span>
                </div>
                <div className="flex items-center text-sm">
                  <span className="text-gray-500 w-24">Joined:</span>
                  <span className="font-semibold text-gray-800">{employeeData.joiningDate}</span>
                </div>
                <div className="flex items-center text-sm">
                  <span className="text-gray-500 w-24">Manager:</span>
                  <span className="font-semibold text-gray-800">{employeeData.reportingManager}</span>
                </div>
              </div>

              <button
                onClick={handleApplyLeave}
                className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 rounded-xl transition"
              >
                Apply Leave
              </button>
            </div>
          </div>

          {/* Leave History */}
          <div className="lg:col-span-1 bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg font-bold text-gray-800">My Recent Leave Requests</h2>
              <button
                onClick={() => setShowAllLeavesModal(true)} // Opens the new "All Leaves History" modal
                className="text-indigo-600 hover:text-indigo-700 text-sm font-medium flex items-center"
              >
                View All
                <ChevronRight className="w-4 h-4 ml-1" />
              </button>
            </div>

            <div className="space-y-4">
              {recentLeaves.length > 0 ? (
                recentLeaves.map((leave) => (
                  <div
                    key={leave.id}
                    className="border border-gray-200 rounded-xl p-4 hover:border-indigo-200 hover:bg-indigo-50/30 transition"
                  >
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex-1">
                        <div className="flex items-center space-x-3 mb-2">
                          <h3 className="font-semibold text-gray-800">{leave.type}</h3>
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-medium text-white ${getStatusBadge(
                              leave.status
                            )}`}
                          >
                            {leave.status}
                          </span>
                        </div>
                        <div className="flex items-center space-x-4 text-sm text-gray-600">
                          <span className="flex items-center">
                            <Calendar className="w-4 h-4 mr-1" />
                            {leave.fromDate} - {leave.toDate}
                          </span>
                          <span className="flex items-center">
                            <Clock className="w-4 h-4 mr-1" />
                            {leave.days} day{leave.days > 1 ? "s" : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-8 text-gray-500">
                  <FileText className="w-12 h-12 mx-auto mb-3 text-gray-300" />
                  <p>No recent leave requests found</p>
                  <p className="text-sm">Apply for leave to see your requests here</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ============================================= */}
      {/* ALL LEAVES HISTORY MODAL (NEW) */}
      {/* ============================================= */}
      {showAllLeavesModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-2xl font-bold text-gray-800">All Leave Requests</h3>
              <button
                onClick={() => setShowAllLeavesModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="space-y-4">
              {allLeaves.length > 0 ? (
                allLeaves.map((leave) => (
                  <div
                    key={leave.id}
                    className="border border-gray-200 rounded-xl p-4 hover:border-blue-200 hover:bg-blue-50/30 transition"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="font-semibold text-gray-800 text-lg">{leave.type}</h3>
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-medium text-white ${getStatusBadge(
                          leave.status
                        )}`}
                      >
                        {leave.status}
                      </span>
                    </div>
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm text-gray-600">
                      <p>
                        <span className="font-medium text-gray-500">From:</span> {leave.fromDate}
                      </p>
                      <p>
                        <span className="font-medium text-gray-500">To:</span> {leave.toDate}
                      </p>
                      <p>
                        <span className="font-medium text-gray-500">Duration:</span> {leave.days} day{leave.days > 1 ? "s" : ""}
                      </p>
                      <p className="col-span-2 sm:col-span-1">
                        <span className="font-medium text-gray-500">Applied On:</span> {leave.appliedOn}
                      </p>
                    </div>
                    {leave.reason && (
                      <p className="text-sm text-gray-700 mt-2">
                        <span className="font-medium text-gray-500">Reason:</span> {leave.reason}
                      </p>
                    )}
                  </div>
                ))
              ) : (
                <div className="text-center py-12 text-gray-500">
                  <FileText className="w-16 h-16 mx-auto mb-4 text-gray-300" />
                  <p className="text-lg font-medium">No leave requests found</p>
                  <p className="text-sm">Apply for leave to see your history here.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ============================================= */}
      {/* LEAVE BALANCE MODAL (RETAINED FROM OLD CODE) */}
      {/* ============================================= */}
      {showLeaveBalanceModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 w-full max-w-2xl">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-2xl font-bold text-gray-800">Leave Balance Details</h3>
              <button
                onClick={() => setShowLeaveBalanceModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="space-y-4">
              {/* Total Leave Balance */}
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-xl border border-green-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-green-600 font-medium mb-1">Total Leave Balance</p>
                    <p className="text-4xl font-bold text-green-700">{stats.leaveBalance} Days</p>
                  </div>
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                    <FileText className="w-8 h-8 text-green-600" />
                  </div>
                </div>
              </div>

              {/* Leave Breakdown (using dummy data as per old code) */}
           <div className="grid grid-cols-2 gap-4">

  {/* Casual Leave */}
  <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
    <p className="text-xs text-blue-600 font-medium mb-2">Casual Leave</p>
    <p className="text-2xl font-bold text-blue-700">{leaveBreakdown.casual} Days</p>
    <p className="text-xs text-blue-500 mt-1">Remaining</p>
  </div>

  {/* Sick Leave */}
  <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
    <p className="text-xs text-purple-600 font-medium mb-2">Sick Leave</p>
    <p className="text-2xl font-bold text-purple-700">{leaveBreakdown.sick} Days</p>
    <p className="text-xs text-purple-500 mt-1">Remaining</p>
  </div>

  {/* Earned Leave */}
  <div className="bg-orange-50 p-4 rounded-lg border border-orange-200">
    <p className="text-xs text-orange-600 font-medium mb-2">Earned Leave</p>
    <p className="text-2xl font-bold text-orange-700">{leaveBreakdown.earned} Days</p>
    <p className="text-xs text-orange-500 mt-1">Remaining</p>
  </div>

</div>


              {/* Apply Leave Button */}
              <button
                onClick={handleApplyLeave}
                className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 rounded-lg transition mt-4"
              >
                Apply for Leave
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ============================================= */}
      {/* PENDING LEAVES MODAL (RETAINED FROM OLD CODE) */}
      {/* ============================================= */}
      {showPendingLeavesModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 w-full max-w-3xl max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-2xl font-bold text-gray-800">Pending Leave Requests</h3>
              <button
                onClick={() => setShowPendingLeavesModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="space-y-4">
              {pendingLeavesOnly.length > 0 ? (
                pendingLeavesOnly.map((leave) => (
                  <div
                    key={leave.id}
                    className="border border-amber-200 rounded-xl p-5 bg-amber-50/50 hover:bg-amber-50 transition"
                  >
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex-1">
                        <div className="flex items-center space-x-3 mb-2">
                          <h3 className="font-bold text-gray-800 text-lg">{leave.type}</h3>
                          <span className="px-3 py-1 rounded-full text-xs font-medium text-white bg-amber-500">
                            Pending Approval
                          </span>
                        </div>
                        <div className="grid grid-cols-2 gap-3 text-sm mb-3">
                          <div>
                            <p className="text-gray-500 text-xs">From Date</p>
                            <p className="font-semibold text-gray-800">{leave.fromDate}</p>
                          </div>
                          <div>
                            <p className="text-gray-500 text-xs">To Date</p>
                            <p className="font-semibold text-gray-800">{leave.toDate}</p>
                          </div>
                          <div>
                            <p className="text-gray-500 text-xs">Duration</p>
                            <p className="font-semibold text-gray-800">
                              {leave.days} day{leave.days > 1 ? "s" : ""}
                            </p>
                          </div>
                          <div>
                            <p className="text-gray-500 text-xs">Manager</p>
                            <p className="font-semibold text-gray-800">{employeeData.reportingManager}</p>
                          </div>
                        </div>
                        {leave.reason && (
                          <div className="bg-white p-3 rounded-lg border border-gray-200">
                            <p className="text-xs text-gray-500 mb-1">Reason</p>
                            <p className="text-sm text-gray-700">{leave.reason}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-12">
                  <Clock className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                  <p className="text-gray-500 text-lg">No pending leave requests</p>
                  <p className="text-sm text-gray-400">All your leave requests have been processed</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ============================================= */}
      {/* WORKING HOURS DETAIL MODAL (NEW) */}
      {/* ============================================= */}
      {showWorkingHoursModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-2xl font-bold text-gray-800">Working Hours Details</h3>
              <button
                onClick={() => setShowWorkingHoursModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="space-y-4">
              {/* Total Hours Worked */}
              <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-blue-600 font-medium mb-1">Total Hours Worked This Month</p>
                    <p className="text-4xl font-bold text-blue-700">{stats.totalHoursWorked}h</p>
                  </div>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                    <Briefcase className="w-8 h-8 text-blue-600" />
                  </div>
                </div>
              </div>

              {/* Overtime Hours */}
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-xl border border-purple-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-purple-600 font-medium mb-1">Overtime Hours This Month</p>
                    <p className="text-4xl font-bold text-purple-700">{stats.overtimeHours}h</p>
                  </div>
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center">
                    <Clock className="w-8 h-8 text-purple-600" />
                  </div>
                </div>
              </div>

              {/* Expected vs Actual */}
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                  <p className="text-xs text-gray-600 font-medium mb-2">Expected Working Hours</p>
                  <p className="text-2xl font-bold text-gray-700">{stats.expectedHours}h</p>
                  <p className="text-xs text-gray-500 mt-1">Based on monthly working days</p>
                </div>
                <div className="bg-teal-50 p-4 rounded-lg border border-teal-200">
                  <p className="text-xs text-teal-600 font-medium mb-2">Difference (Actual - Expected)</p>
                  <p className="text-2xl font-bold text-teal-700">
                    {stats.totalHoursWorked - stats.expectedHours}h
                  </p>
                  <p className="text-xs text-teal-500 mt-1">
                    {stats.totalHoursWorked - stats.expectedHours >= 0 ? "Above" : "Below"} Expected
                  </p>
                </div>
              </div>

              {/* Action Button (e.g., View Detailed Timesheet) */}
              <button className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 rounded-lg transition mt-4">
                View Detailed Timesheet
              </button>
            </div>
          </div>
        </div>
      )}

     
    </div>
  );
};

export default ManagerMyInfo;
